<template>
  <v-app>
    <v-app-bar app color="#121212" flat>
      <template v-slot:prepend>
        <v-app-bar-nav-icon
          variant="text"
          @click.stop="drawer = !drawer"
        ></v-app-bar-nav-icon>
      </template>
      <v-app-bar-title class="font-weight-bold">
        <router-link :to="{ name: 'home' }">
          <v-img
            alt="Andromeda Logo"
            class="d-inline-block mt-2"
            width="58px"
            height="58px"
            contain
            src="/img/logo/andromeda_logomark.svg"
            transition="scale-transition"
          />
        </router-link>
      </v-app-bar-title>
      <v-btn
        href="https://github.com/AndromedaTechnology"
        class="mb-5 hover-bg-no"
        text
      >
        <v-img
          src="/img/social/github.webp"
          height="56px"
          width="56px"
          contain
        ></v-img>
      </v-btn>
    </v-app-bar>
    <v-main>
      <v-navigation-drawer
        v-model="drawer"
        :location="$vuetify.display.mobile ? 'bottom' : undefined"
        :color="$vuetify.display.mobile ? 'black' : 'rgba(0,0,0,0)'"
        style="border: none !important; box-shadow: none !important; z-index: 999999;"
        temporary
      >
        <v-list-item
          v-for="item in items"
          :key="item.title"
          link
          :href="item.value"
          :title="item.title"
        ></v-list-item>
      </v-navigation-drawer>
      <router-view></router-view>
    </v-main>
    <SWUpdate />
  </v-app>
</template>
<script lang="ts">
import { defineComponent } from 'vue'
import type { PropType } from 'vue'
import SWUpdate from "./components/general/SWUpdate.vue";

interface Item {
  name: string
}

export default defineComponent({
  name: "App",
  components: {
    SWUpdate,
  },
  props: {
    item: {
      type: Object as PropType<Item>,
      required: true
    },
  },
  data () {
    return {
      drawer: false,
      items: [
        {
          title: 'Home',
          value: '/',
        },
        {
          title: 'Startups',
          value: '/Startups#Startups',
        },
        {
          title: 'Projects',
          value: '/Startups#OpenSource',
        },
        {
          title: 'Essays',
          value: '/#Essays',
        },
        {
          title: 'Technology Stack',
          value: '/#TechnologyStack',
        },
        // {
        //   title: 'Podcasts',
        //   value: '#Podcasts',
        // },
        {
          title: 'Contact',
          value: '/#Contact',
        },
      ]
    }
  },
})
</script>

<style lang="scss">
body {
  background-color: #121212 !important;
}
.v-responsive__content.narrow {
  width: 96px !important;
}
.hover-bg-no.v-btn .v-ripple__container {
  opacity: 0 !important;
}
.hover-bg-no.v-btn::before {
  background-color: transparent !important;
}
</style>